<template>
    <div class="mc-tips" v-show="showTips">
        <p @click="toLink"><font>前往<span>河北日报</span> 客户端才可参与活动哦~</font></p> 
        <span class="close-mc" @click="closeTips">关闭提醒</span>
    </div>
</template>

<script>

import jump2hbrb from '@/utils/jump2app-hb.js'

export default {
  name:'tips',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
        showTips:true,
        accountId: '',
        uniqueId: '',
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted() {
    this.checkTips()
    if (process.env.NODE_ENV === 'development') { // 开发环境
        // 指定用户登录测试
        let accountId = '6358b3359f78a023d2b3ff8c';
        let uniqueId = '6aca1fd5c83330087e7ab21d';
        this.accountId = accountId;
        this.uniqueId = uniqueId;
        this.$store.commit("SET_ACCOUNTID",accountId);
        this.$store.commit("SET_UNIQUEID",uniqueId);    
        this.logged();
        // this.cpLoad(true)  //日报客户端js-sdk加载并初始化
    } else if (process.env.NODE_ENV === 'production') { // 生产环境        
        this.cpLoad(true)  //日报客户端js-sdk加载并初始化
    }
    
  },
  methods: {    
    cpLoad(runAll) {
      let _this = this; 
      let cpMain = function() {        
          let is_login = false;
          CP.getDeviceInfo({
              completed: function(data){
                  // data > {device_no:'',system:'',system_version:'',device_type:'',timestamp: '',signature：'', app: '', version: '', networkType: '', statusBarHeight: ''}
                  CP.tools.writelog('get_device_info', data);                   
                  console.log('hbrb_version',data.version);
              },
              cpIncompatible: function () {
                  CP.tools.writelog('CP.getDeviceInfo', '此环境不支持此方法');
              }
          });
          //自身的业务代码，以下为调用样例
          CP.isLogin({  //判断是否登录的接口，
            completed: function(data){
            CP.tools.writelog('get_is_login', data);			
            if(data.is_login==1) {
              is_login=true;					
              //获取unique_id
              CP.getUniqueId({
                completed: function(data){
                  console.log('data.unique_id',data.unique_id);
                  _this.$store.commit("SET_UNIQUEID",data.unique_id);
                  _this.uniqueId = data.unique_id;
                  //获取account_id
                  CP.getAccountId({
                    completed: function(data){
                      console.log('data.account_id',data.account_id);
                      _this.$store.commit("SET_ACCOUNTID",data.account_id);
                      _this.accountId = data.account_id;
                      _this.logged();
                    },
                    cpIncompatible: function () {
                      CP.tools.writelog('CP.getAccountId', '此环境不支持此方法');
                    }
                  });
                },
                cpIncompatible: function () {
                  CP.tools.writelog('CP.getUniqueId', '此环境不支持此方法');
                }
              });
            } else {
              //调用用户登录窗口
              CP.showLogin({
                completed: function(data){
                  if(data.is_login==1) {
                    console.log(data.account_id);
                    _this.$store.commit("SET_UNIQUEID",data.unique_id);
                    _this.$store.commit("SET_ACCOUNTID",data.account_id);
                    _this.uniqueId = data.unique_id;
                    _this.accountId = data.account_id;
                    _this.logged();
                  }
                  CP.tools.writelog('show_login', data);
                },
                cpIncompatible: function () {
                  CP.tools.writelog('CP.showLogin', '此环境不支持此方法');
                }
              });
            }   
          },
          cpIncompatible: function () {
            CP.tools.writelog('CP.isLogin', '此环境不支持此方法');
          }
          });
      }

      if(runAll) {
        let zjrbCp = document.createElement('script');
        zjrbCp.async = "async";
        zjrbCp.src = 'https://cdn-cp.tmuyun.com/jssdk/v1/zjrb-cp.v1.min.js';
        zjrbCp.charset = "UTF-8";
        document.body.appendChild(zjrbCp);     
        
        localStorage.setItem('hbrb_account_id', '');
        localStorage.setItem('hbrb_unique_id', '');

        zjrbCp.onload = function(){
          if(CP && typeof CP.ready === 'function'){
              console.log("CP准备就绪");
              CP.ready({
                debug:false,  //可选，是否是开启调试模式, 默认false
                es6Require: false, //可选，是否需要加载es6库，默认false
                ready:function(client_info){
                  //jssdk加载完成调用此方法
                  console.log('业务逻辑初始化开始');
                  cpMain();// 业务逻辑初始化的main函数
                },
                error: function (error) {
                  console.log('出现错误',error);
                }
              });
          }
        }
      } else {
        cpMain();// 业务逻辑初始化的main函数
      }
    },
    logged() {
      if (this.$parent && typeof this.$parent.loginInit === 'function') {
        this.$parent.loginInit();
      } else {
        console.log('父组件不存在 loginInit 方法');
      }
    },
    checkTips() {
        if (/(hbxw)/i.test(navigator.userAgent)) {
            this.showTips = false;
        } else {
            this.showTips = true;
        }
    },
    toLink() {
        jump2hbrb.toMLink(window.location.href)
    },
    closeTips() {
        this.showTips = false;
    }
  },
}
</script>
<style scoped>

/* 页面顶部日报客户端下载提示 */
.mc-tips {position: fixed; z-index: 999; top: 0; width: 750px; height: 60px; background-color: rgba(74,74,74,.8); line-height: 60px; font-size: 26px; font-weight: 300; display: flex; align-items: center; }
.mc-tips p { color: #fff; width: 80%!important; min-height: 100%; padding: 0px; margin: 0px; text-align: center;}
.mc-tips p span {color: #e8a211;}
.mc-tips .close-mc { width: 20%; height: 100%; display: flex; align-items: center; justify-content: center; color: #4990e2;}
/*字数滚动*/
.mc-tips p { width: 300px; height:60px; display: flex; align-items: center; font-size: 26px; margin: 0 auto; white-space: nowrap; /*文字不折行*/ overflow: hidden; /*文字溢出隐藏*/ }
.mc-tips p font{ display: inline-block;/*inline样式不能使用动画*/ animation: scroll 15s linear infinite; /*滚动动画*/ font-size: 26px; font-weight: 300; line-height: 60px;}       
@keyframes scroll {
    from {
        transform: translateX(300px); /*div多宽就写多宽*/
    }
    to {
        transform: translateX(-100%);
    }
} 
</style>
